<ng-container>
    <div class="inside-container" *ngIf="!editMode && userDetails">
        <div fxLayout="row">
            <div fxFlex="70" fxLayoutAlign="start center">
                <h3 class="tab-header"
                    >{{ translate.get(tabType) }} <span i18n="@@Details" t="Details">Details</span></h3
                >
                <a target="_blank" [href]="helpUrl">
                    <tsl-icon class="header-help-icon" size="small">help</tsl-icon>
                </a>
            </div>
        </div>
        <br />

        <!-- search box -->
        <div>
            <div fxLayoutAlign="space-around end" fxLayoutGap="10px">
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@0fbc0bbce830bd50141fac696299f15bed5563c8"
                        t="0fbc0bbce830bd50141fac696299f15bed5563c8"
                        >Category</tsl-label
                    >
                    <tsl-select
                        id="filter_category"
                        fullWidth
                        [(ngModel)]="filter.toolCategory"
                        (selectionChange)="onChangeCategory($event)"
                    >
                        <tsl-option *ngFor="let cat of filterCategories" [value]="cat.id">{{
                            translate.get(cat.category)
                        }}</tsl-option>
                    </tsl-select>
                </tsl-form-field>

                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@301aa836dcab43dc07491c377b37e32132225c19"
                        t="301aa836dcab43dc07491c377b37e32132225c19"
                        >Sub-Category</tsl-label
                    >
                    <tsl-select
                        id="filter_subcategory"
                        fullWidth
                        [(ngModel)]="filter.toolSubcategory"
                        (selectionChange)="onChangeSubcategory($event)"
                    >
                        <tsl-option *ngFor="let sub of filterSubcategories" [value]="sub.id">{{
                            translate.get(sub.subcategory)
                        }}</tsl-option>
                    </tsl-select>
                </tsl-form-field>

                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@fcd8accd435979359c4e5cdf789d5971ac710435"
                        t="fcd8accd435979359c4e5cdf789d5971ac710435"
                        >Asset Tag Number</tsl-label
                    >
                    <input
                        id="filter_asset"
                        tslInput
                        fullWidth
                        maxlength="50"
                        autocomplete="off"
                        [tslAutocomplete]="filterAsset"
                        [formControl]="filterAssetNumber"
                    />
                    <tsl-autocomplete
                        #filterAsset="tslAutocomplete"
                        [displayWith]="assetAutoDisplay"
                        (optionSelected)="onSelectFilterAsset($event.option)"
                    >
                        <tsl-option *ngFor="let asset of filterAssetsFiltered$ | async" [value]="asset">
                            {{ asset.assetCode }} - {{ asset.assetDescription }}</tsl-option
                        >
                    </tsl-autocomplete>
                </tsl-form-field>

                <tsl-form-field fxFlex>
                    <tsl-label i18n="@@Status" t="Status">Status</tsl-label>
                    <tsl-select id="filter_status" fullWidth [(ngModel)]="filter.status">
                        <tsl-option
                            [value]="'active'"
                            i18n="@@b36e1450940b7f6028d8587568c7d669b53f7a06"
                            t="b36e1450940b7f6028d8587568c7d669b53f7a06"
                            >Active</tsl-option
                        >
                        <tsl-option
                            [value]="'future'"
                            i18n="@@18a5dd7f62a3e97a4df965ffbdb11cce448b41c0"
                            t="18a5dd7f62a3e97a4df965ffbdb11cce448b41c0"
                            >Future</tsl-option
                        >
                        <tsl-option
                            [value]="'notactive'"
                            i18n="@@6f44e5ac01cb0823e4b621f777cad31aac81bff6"
                            t="6f44e5ac01cb0823e4b621f777cad31aac81bff6"
                            >Not Active</tsl-option
                        >
                        <tsl-option
                            [value]="'service'"
                            i18n="@@d473e0f684a60db45d6f31e993f693f74290e056"
                            t="d473e0f684a60db45d6f31e993f693f74290e056"
                            >Service</tsl-option
                        >
                    </tsl-select>
                </tsl-form-field>

                <tsl-form-field fxFlex>
                    <tsl-label i18n="@@Name" t="Name">Name</tsl-label>
                    <input tslInput maxlength="100" fullWidth [(ngModel)]="filter.name" />
                </tsl-form-field>
            </div>
            <div class="left">
                <button
                    tsl-button
                    color="blue"
                    size="small"
                    (click)="onFilter()"
                    i18n="@@7e892ba15f2c6c17e83510e273b3e10fc32ea016"
                    t="7e892ba15f2c6c17e83510e273b3e10fc32ea016"
                    >Search</button
                >
                <button
                    tsl-button
                    color="black"
                    outline
                    size="small"
                    (click)="onClearFilter()"
                    i18n="@@99ee4faa69cd2ea8e3678c1f557c0ff1f05aae46"
                    t="99ee4faa69cd2ea8e3678c1f557c0ff1f05aae46"
                    >Clear</button
                >
                <button
                    tsl-button
                    color="black"
                    outline
                    size="small"
                    (click)="exportToExcel()"
                    i18n="@@ExportToExcel"
                    t="ExportToExcel"
                    >Export To Excel</button
                >
            </div>
        </div>
        <br />

        <div>
            <div
                class="right-container"
                *ngIf="
                    this.userDetails &&
                    (this.userDetails.isSupplier || (this.userDetails.isTeslaUser && this.userDetails.isSIE))
                "
            >
                <button
                    *ngIf="userDetails.isTeslaUser"
                    tsl-button
                    color="black"
                    outline
                    size="small"
                    (click)="manageDefaults()"
                    i18n="@@181a6368a4bdb0182892f881812c3f99803b80e1"
                    t="181a6368a4bdb0182892f881812c3f99803b80e1"
                    >Manage Defaults</button
                >
                <button
                    *ngIf="!isEquipment"
                    tsl-button
                    color="blue"
                    size="small"
                    [disabled]="preventativeHold==true"
                    (click)="createTool()"
                    i18n="@@12a36c17b567838560190cf2d50f512b265db098"
                    t="12a36c17b567838560190cf2d50f512b265db098"
                    >Create New Tool</button
                >
                <button
                    *ngIf="isEquipment"
                    tsl-button
                    [disabled]="preventativeHold==true"
                    color="blue"
                    size="small"
                    (click)="createTool()"
                    i18n="@@6710927b8443196875f05011404258240ef2771c"
                    t="6710927b8443196875f05011404258240ef2771c"
                    >Create New Equipment</button
                >
            </div>
            <div class="sticky-table">
                <table tsl-table [dataSource]="toolResult?.items">
                    <ng-container tslColumnDef="id">
                        <th
                            tsl-header-cell
                            *tslHeaderCellDef
                            i18n="@@86f653fb055960bde2d1dd3498a6498222a1701b"
                            t="86f653fb055960bde2d1dd3498a6498222a1701b"
                        >
                            Id</th
                        >
                        <td tsl-cell *tslCellDef="let tool"> {{ tool.id }} </td>
                    </ng-container>

                    <ng-container tslColumnDef="name">
                        <th
                            tsl-header-cell
                            *tslHeaderCellDef
                            i18n="@@20371277706eedf7fd8a3f51633ca5d801cd4fc2"
                            t="20371277706eedf7fd8a3f51633ca5d801cd4fc2"
                        >
                            Name
                        </th>
                        <td tsl-cell *tslCellDef="let tool"> {{ translate.get(tool.data.name) }} </td>
                    </ng-container>

                    <ng-container tslColumnDef="category">
                        <th
                            tsl-header-cell
                            *tslHeaderCellDef
                            i18n="@@a5af6340df79c70f88c0c08d5c23568a9eed0bfa"
                            t="a5af6340df79c70f88c0c08d5c23568a9eed0bfa"
                        >
                            Category
                        </th>
                        <td tsl-cell *tslCellDef="let tool"> {{ translate.get(tool.toolCategory) }} </td>
                    </ng-container>

                    <ng-container tslColumnDef="subCategory">
                        <th
                            tsl-header-cell
                            *tslHeaderCellDef
                            i18n="@@abcaaaa29f668f2d8515e4a0799f238d7fbc7456d1e1a6baaa"
                            t="29f668f2d8515e4a0799f238d7fbc7456d1e1a6b"
                        >
                            Sub-Category
                        </th>
                        <td tsl-cell *tslCellDef="let tool"> {{ translate.get(tool.toolSubcategory) }} </td>
                    </ng-container>

                    <ng-container tslColumnDef="isAsset">
                        <th
                            tsl-header-cell
                            *tslHeaderCellDef
                            i18n="@@761408760b10b7c257e97b178ee0e27829ba646c"
                            t="761408760b10b7c257e97b178ee0e27829ba646c"
                        >
                            Is Asset?
                        </th>
                        <td tsl-cell *tslCellDef="let tool">
                            <tsl-icon *ngIf="tool.data.isTeslaAsset">check_circle</tsl-icon>
                        </td>
                    </ng-container>

                    <ng-container tslColumnDef="assetNumber">
                        <th
                            tsl-header-cell
                            *tslHeaderCellDef
                            i18n="@@4af86399a6946ab4c8eab6b1a228bf1d2d453831"
                            t="4af86399a6946ab4c8eab6b1a228bf1d2d453831"
                        >
                            Asset Tag Number - Description - (status)
                        </th>
                        <td tsl-cell *tslCellDef="let tool">
                            <ul class="no-decoration">
                                <li class="asset-list" *ngFor="let asset of tool.data.assets"
                                    >{{ assetAutoDisplay(asset) }}
                                </li>
                            </ul>
                        </td>
                    </ng-container>

                    <ng-container tslColumnDef="status">
                        <th
                            tsl-header-cell
                            *tslHeaderCellDef
                            i18n="@@5f94c6664a33089cb2e25df03212692d866e1866"
                            t="5f94c6664a33089cb2e25df03212692d866e1866"
                        >
                            Tool Status
                        </th>
                        <td tsl-cell *tslCellDef="let tool">
                            {{ tooolAssetAutoDisplay(translate.get(tool.data.status)) }}
                        </td>
                    </ng-container>

                    <ng-container tslColumnDef="condition">
                        <th
                            tsl-header-cell
                            *tslHeaderCellDef
                            i18n="@@9a0a7e3adb5df62ca71e0eb440ac10d963a0c540"
                            t="abcaaa9a0a7e3adb5df62ca71e0eb440ac10d963a0c540aaa"
                        >
                            Asset Condition
                        </th>
                        <td tsl-cell *tslCellDef="let tool"> {{ translate.get(tool.assetCondition) }} </td>
                    </ng-container>

                    <ng-container tslColumnDef="action">
                        <th tsl-header-cell *tslHeaderCellDef i18n="@@Action" t="Action">Action</th>
                        <td tsl-cell *tslCellDef="let tool">
                            <button
                                tsl-icon-button
                                i18n-matTooltip
                                matTooltip="Edit"
                                (click)="onEditTool(tool)"
                                *ngIf="
                                    this.userDetails && (this.userDetails.isSupplier || this.userDetails.isTeslaUser)
                                "
                            >
                                <tsl-icon status="primary">edit</tsl-icon>
                            </button>
                            <button
                                tsl-icon-button
                                i18n-matTooltip
                                matTooltip="Copy"
                                *ngIf="
                                    tool.id &&
                                    this.userDetails &&
                                    (this.userDetails.isSupplier ||
                                        (this.userDetails.isTeslaUser && this.userDetails.isSIE))
                                "
                                (click)="onCopyTool(tool)"
                            >
                                <tsl-icon status="primary">file_copy</tsl-icon>
                            </button>
                            <button
                                tsl-icon-button
                                i18n-matTooltip
                                matTooltip="Delete"
                                *ngIf="
                                    tool.id &&
                                    this.userDetails &&
                                    (this.userDetails.isSupplier ||
                                        (this.userDetails.isTeslaUser && this.userDetails.isSIE))
                                "
                                (click)="onDeleteTool(tool)"
                            >
                                <tsl-icon status="error">delete</tsl-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr tsl-header-row *tslHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
            <tsl-pagination
                [pageSizeOptions]="pageSizeOptions"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                showFirstLastButtons
                (pageChange)="onPageChange($event)"
                [total]="toolResult.totalRecords"
                [itemsPerPageLabel]="translate.get('ItemsPerPage')"
            >
            </tsl-pagination>
        </div>
    </div>
</ng-container>
<div *ngIf="editMode">
    <tool-form #toolEquipmentForm [isEquipment]="isEquipment" [currentTool]="selectedTool" (close)="closeForm($event)">
    </tool-form>
</div>
